import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Partner\BcSolutions\GetCompanyBcSolutionsStatusController::__invoke
* @see app/Http/Controllers/Partner/BcSolutions/GetCompanyBcSolutionsStatusController.php
* @route '/api/company/{company}/peppol/bcsolutions/status'
*/
const GetCompanyBcSolutionsStatusController = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCompanyBcSolutionsStatusController.url(args, options),
    method: 'get',
})

GetCompanyBcSolutionsStatusController.definition = {
    methods: ["get","head"],
    url: '/api/company/{company}/peppol/bcsolutions/status',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Partner\BcSolutions\GetCompanyBcSolutionsStatusController::__invoke
* @see app/Http/Controllers/Partner/BcSolutions/GetCompanyBcSolutionsStatusController.php
* @route '/api/company/{company}/peppol/bcsolutions/status'
*/
GetCompanyBcSolutionsStatusController.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return GetCompanyBcSolutionsStatusController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Partner\BcSolutions\GetCompanyBcSolutionsStatusController::__invoke
* @see app/Http/Controllers/Partner/BcSolutions/GetCompanyBcSolutionsStatusController.php
* @route '/api/company/{company}/peppol/bcsolutions/status'
*/
GetCompanyBcSolutionsStatusController.get = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCompanyBcSolutionsStatusController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Partner\BcSolutions\GetCompanyBcSolutionsStatusController::__invoke
* @see app/Http/Controllers/Partner/BcSolutions/GetCompanyBcSolutionsStatusController.php
* @route '/api/company/{company}/peppol/bcsolutions/status'
*/
GetCompanyBcSolutionsStatusController.head = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetCompanyBcSolutionsStatusController.url(args, options),
    method: 'head',
})

export default GetCompanyBcSolutionsStatusController